export default "__VITE_ASSET__DCwJJP6j__"